import { checkResponse, get } from "@/utils/http";
import { APP_CONFIG } from "@/utils/constants";

export function setting() {
  return get(`${APP_CONFIG.apiUrl}/setting`).then(checkResponse);
}

export function examList() {
  return get(`${APP_CONFIG.apiUrl}/exam/list?special=1`).then(checkResponse);
}

export function examCategoryList() {
  return get(`${APP_CONFIG.apiUrl}/exam/category`).then(checkResponse);
}

export function articleList() {
  return get(`${APP_CONFIG.apiUrl}/article?limit=8`).then(checkResponse);
}
